import React from 'react';


type Props = {
    name: string;
    description: string;
    src: string;
}

const PartnerCard: React.FC<Props> = (props) => {


    return <div className="partner-card col-12 col-md-6 col-lg-3">
        <img className='partner-logo mb-4 rounded'
            src={`https://res.cloudinary.com/ipcmobile/image/upload/c_scale,q_auto:best,w_400/v1/partners/${props.src}`}
            srcSet={`https://res.cloudinary.com/ipcmobile/image/upload/c_scale,q_auto:best,w_800/v1/partners/${props.src}`}
            alt={`${props.name.trim()} logo`} />
        <h4>{`${props.name.slice(0, 1).toUpperCase()}${props.name.slice(1)}`}</h4>
        <p>{props.description}</p>
    </div>

}

export default PartnerCard;
